import * as Yup from 'yup';

export const P100SecurityQuestionsSchema = Yup.object().shape({
  claimHistory: Yup.number().label('Claims History').required(),
  useEncryption: Yup.bool()
    .label('Encryption of sensitive information')
    .required(),
  useCloudStorage: Yup.bool().label('Use cloud storage').required(),
  isSecurityTraining: Yup.bool()
    .label('Organization Security Training')
    .required(),
  isSecurityOfficer: Yup.bool()
    .label('Organization Security Officer')
    .required(),
});

export const AccountOrgContactSchema = Yup.object().shape({
  contactFirstName: Yup.string().label('Contact First Name').required(),
  contactLastName: Yup.string().label('Contact Last Name').required(),
  contactEmail: Yup.string().label('Contact Email').email().required(),
  contactPhone: Yup.number()
    .label('Phone Number')
    .fromPhone()
    .phone()
    .required(),
});
